<header class="navbar">
    <!-- HAMBURGER (Mobile) -->
    <div class="hamburger" (click)="toggleMenu()">
        <span></span>
        <span></span>
        <span></span>
    </div>

    <!-- LEFT LINKS (Desktop) -->
    <nav class="menu desktop left">
        <ul class="links">
            <li><a routerLink="/home" routerLinkActive="active">Home</a></li>
            <li><a routerLink="/about" routerLinkActive="active">About</a></li>
            <li><a routerLink="/shop" routerLinkActive="active">Products</a></li>
            <li><a routerLink="/shop" [queryParams]="{  problem: 'a8fb0923-f0c7-47e3-b417-f2dd48320d14' }">Skin Care</a>
            </li>
            <li><a routerLink="/shop" [queryParams]="{  problem: '2910b720-c0d9-4e9c-a7ea-07054371d19e' }">Hair Care</a>
            </li>
            <li><a routerLink="/shop" [queryParams]="{ problem: 'b0054c90-05b2-4cb4-a726-72bd716a18cd' }">Body Care</a>
            </li>
        </ul>
    </nav>

    <!-- CENTER LOGO -->
    <div class="brand">
        <a routerLink="/">
            <img
                    src="assets/images/logo.webp"
                    loading="lazy"
                    alt="Logo" class="logo">

        </a>
    </div>

    <!-- RIGHT ICONS (Desktop) -->
    <nav class="menu desktop">
        <ul class="links">
            <li>
                <a routerLink="/admin" routerLinkActive="active" *ngIf="isAdmin">Admin</a>
                <a class="left" routerLink="/testimonial" routerLinkActive="active">Testimonial</a>
            </li>
            <li>
                <a class="left" routerLink="/contact" routerLinkActive="active">
                    <fa-icon [icon]="faEnvelope"></fa-icon>
                </a>
            </li>
            <li class="cart-wrapper right">
                <a routerLink="/cart">
                    <fa-icon [icon]="faShoppingCart"></fa-icon>
                    <span class="cart-count" *ngIf="cartCount > 0">{{ cartCount }}</span>
                </a>
            </li>
            <li>
                <a routerLink="/wishlist">
                    <fa-icon [icon]="faHeart"></fa-icon>
                </a>
            </li>
            <li>
                <a (click)="triggerLogin()">
                    <fa-icon [icon]="faUser"></fa-icon>
                </a>
            </li>
        </ul>
    </nav>
</header>

<!-- MOBILE SIDE MENU -->
<div class="side-menu" [class.active]="isMenuOpen">

    <!-- Close Button -->
    <button class="close-btn" type="button" (click)="isMenuOpen = false">×</button>
    <a
            class="login-btn"
            style="height: auto;overflow: auto;"
            (click)="navLogin()"
            *ngIf="!isLoggedIn">
        <fa-icon [icon]="faUser"></fa-icon>
    </a>

    <div class="logo">
        <a routerLink="/" (click)="toggleMenu()">
            <img
                    src="assets/images/logo.webp"
                    loading="lazy"
                    alt="Logo" class="logo">

        </a>
    </div>


    <!-- Shop By Category -->
    <div class="menu-section">
        <div class="section-title" (click)="toggleSection('category')">
            Shop By Category
        </div>

        <ul *ngIf="openSection === 'category'">
            <li routerLink="/shop" [queryParams]="{  problem: 'a8fb0923-f0c7-47e3-b417-f2dd48320d14' }"
                (click)="toggleMenu()">Skin Care
            </li>
            <li routerLink="/shop" [queryParams]="{  problem: '2910b720-c0d9-4e9c-a7ea-07054371d19e' }"
                (click)="toggleMenu()">Hair Care
            </li>
            <li routerLink="/shop" [queryParams]="{ problem: 'b0054c90-05b2-4cb4-a726-72bd716a18cd' }"
                (click)="toggleMenu()">Body Care
            </li>
            <li routerLink="/shop" [queryParams]="{  problem: 'd7e93169-1841-4bb8-9860-5b799d27f509' }"
                (click)="toggleMenu()">Baby Care
            </li>
            <li routerLink="/shop" [queryParams]="{  problem: '30d8056f-618f-42f1-985a-9a8f3d5ff664'}"
                (click)="toggleMenu()">Teeth Care
            </li>
        </ul>
    </div>

    <!-- Shop By Problems -->
    <div class="menu-section">
        <div class="section-title" (click)="toggleSection('problems')">
            Shop By Customer Problems
        </div>

        <ul *ngIf="openSection === 'problems'">
            <li *ngFor="let combo of combos"
                [routerLink]="['/shop', combo.id]"
                (click)="toggleMenu()">
                <strong>
                    {{ combo.name.split('.')[0] }}. </strong>
                    <strong>{{ combo.name.split('.').slice(1).join('.') }}
                </strong>
            </li>
        </ul>
    </div>

    <!-- Customer Review -->
    <div class="menu-section">
        <div class="section-title" routerLink="/testimonial" (click)="toggleMenu()">
            Customer Review
        </div>
    </div>

    <!-- About -->
    <div class="menu-section">
        <div class="section-title" routerLink="/about" (click)="toggleMenu()">
            About Bhagyajit
        </div>
    </div>

    <!-- About -->
    <div class="menu-section">
        <div class="section-title" routerLink="/contact" (click)="toggleMenu()">
            Contact Us
        </div>
    </div>

</div>

<!-- BACKDROP -->
<div class="backdrop" [class.active]="isMenuOpen" (click)="toggleMenu()"></div>
